export const columnsCsv = [
  { label: "Full Name", key: "fullName" },
  { key: "phoneNumber", label: "Mobile Number" },
  { label: "Branch Id ", key: "branchId" },
  //   { key: "companyName", label: "Corporate Name" },
  { key: "emiratesId", label: "Emirates Id" },
  { key: "cardSerialNo", label: "Card Serial Number" },
  //   { key: "registrationDate", label: "Registration Date" },
  {
    key: "kycStatus",
    label: "KYC Added",
  },
];

export const options = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
  //   { value: "Blocked", label: "Blocked" },
];
